import type z from 'zod/v4'
import { index, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

export const Keyword = pgTable(
  'keyword',
  {
    id: uuid().notNull().primaryKey(),
    name: text().notNull(),
    description: text(),
    legacyNeonBookKeywordId: uuid(),
    legacyNeonTagId: uuid(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
    createdAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
  },
  (columns) => [
    index('keyword_name_idx').on(columns.name),
    index('keyword_updated_at_idx').on(columns.updatedAt),
    index('keyword_created_at_idx').on(columns.createdAt),
  ],
)

export const InsertKeywordSchema = createInsertSchema(Keyword)
export const UpdateKeywordSchema = createUpdateSchema(Keyword)
  .omit({ id: true, legacyNeonBookKeywordId: true, legacyNeonTagId: true })
  .partial()
export const SelectKeywordSchema = createSelectSchema(Keyword)

export type InsertKeyword = typeof Keyword.$inferInsert
export type UpdateKeyword = z.infer<typeof UpdateKeywordSchema>
export type SelectKeyword = typeof Keyword.$inferSelect
